// @ts-nocheck
export const ADD_BULK_TASK_REQUEST = 'ADD_BULK_TASK_REQUEST';
export const ADD_BULK_TASK_SUCCESS = 'ADD_BULK_TASK_SUCCESS';
export const ADD_BULK_TASK_FAILURE = 'ADD_BULK_TASK_FAILURE';
export const UPDATE_TASK_NAME_REQUEST = 'UPDATE_TASK_NAME_REQUEST';
export const UPDATE_TASK_NAME_SUCCESS = 'UPDATE_TASK_NAME_SUCCESS';
export const UPDATE_TASK_NAME_FAILURE = 'UPDATE_TASK_NAME_FAILURE';
export const DELETE_TASK_REQUEST = 'DELETE_TASK_REQUEST';
export const DELETE_TASK_SUCCESS = 'DELETE_TASK_SUCCESS';
export const DELETE_TASK_FAILURE = 'DELETE_TASK_FAILURE';
export const GET_BULK_TASK_REQUEST = 'GET_BULK_TASK_REQUEST';
export const GET_BULK_TASK_SUCCESS = 'GET_BULK_TASK_SUCCESS';
export const GET_BULK_TASK_FAILURE = 'GET_BULK_TASK_FAILURE';
export const GENERATE_SUB_TASK_ROW = 'GENERATE_SUB_TASK_ROW';
export const GENERATE_RESOURCE_ROW = 'GENERATE_RESOURCE_ROW';
export const DELETE_SUB_TASK_ROW = 'DELETE_SUB_TASK_ROW';
export const DELETE_RESOURCE_ROW = 'DELETE_RESOURCE_ROW';
export const HANDLE_SUB_TASK_CHANGE = 'HANDLE_SUB_TASK_CHANGE';
export const HANDLE_RESOURCE_CHANGE = 'HANDLE_RESOURCE_CHANGE';
export const UPDATE_RESOURCE_ROW = 'UPDATE_RESOURCE_ROW';
export const RESET_DELETE_ROW_SUCCESS = 'RESET_DELETE_ROW_SUCCESS';
export const RESET_GENERATE_ROW_SUCCESS = 'RESET_GENERATE_ROW_SUCCESS';
export const UPDATE_TASK_WITH_ERR_MSG = 'UPDATE_TASK_WITH_ERR_MSG';
export const RESET_TASK = 'RESET_TASK';
export const RESET_LOADER = 'RESET_LOADER';
export const GET_DROPDOWN_TASK_LIST_REQUEST = 'GET_DROPDOWN_TASK_LIST_REQUEST';
export const GET_DROPDOWN_TASK_LIST_SUCCESS = 'GET_DROPDOWN_TASK_LIST_SUCCESS';
export const GET_DROPDOWN_TASK_LIST_FAILURE = 'GET_DROPDOWN_TASK_LIST_FAILURE';
export const GET_DROPDOWN_SUBTASK_LIST_REQUEST =
  'GET_DROPDOWN_SUBTASK_LIST_REQUEST';
export const GET_DROPDOWN_SUBTASK_LIST_SUCCESS =
  'GET_DROPDOWN_SUBTASK_LIST_SUCCESS';
export const GET_DROPDOWN_SUBTASK_LIST_FAILURE =
  'GET_DROPDOWN_SUBTASK_LIST_FAILURE';
export const GET_DROPDOWN_RESOURCE_LIST_REQUEST =
  'GET_DROPDOWN_RESOURCE_LIST_REQUEST';
export const GET_DROPDOWN_RESOURCE_LIST_SUCCESS =
  'GET_DROPDOWN_RESOURCE_LIST_SUCCESS';
export const GET_DROPDOWN_RESOURCE_LIST_FAILURE =
  'GET_DROPDOWN_RESOURCE_LIST_FAILURE';
export const CLEAR_DROPDOWN_SUBTASK_LIST = 'CLEAR_DROPDOWN_SUBTASK_LIST';
export const GET_DROPDOWN_CATEGORY_LIST_REQUEST =
  'GET_DROPDOWN_CATEGORY_LIST_REQUEST';
export const GET_DROPDOWN_CATEGORY_LIST_SUCCESS =
  'GET_DROPDOWN_CATEGORY_LIST_SUCCESS';
export const DELETE_SUBTASK_REQUEST = 'DELETE_SUBTASK_REQUEST';
export const DELETE_SUBTASK_SUCCESS = 'DELETE_SUBTASK_SUCCESS';
export const DELETE_SUBTASK_FAILURE = 'DELETE_SUBTASK_FAILURE';
export const DELETE_RESOURCE_REQUEST = 'DELETE_RESOURCE_REQUEST';
export const DELETE_RESOURCE_SUCCESS = 'DELETE_RESOURCE_SUCCESS';
export const SELECT_TASK_FOR_EDIT = 'SELECT_TASK_FOR_EDIT';
export const RESET_SELECTED_TASK_ID = 'RESET_SELECTED_TASK_ID';
export const CLEAR_REDUCER = 'task/clear/CLEAR_REDUCER';
